import React from "react";
import Modal, {ModalTitle, ModalProps} from "@/app/pwa/components/Modal";
import Link from "next/link";
import {eventTypeSchema} from "@vereinsheim/backend-types/src/event";
import {pwaEventNewPath} from "@/utils/urlHelper";


interface EventNewSelectEventModalProps extends ModalProps {
  teamId?: string;
  canCreateClubEvent: boolean;
  canCreateTeamEvent: boolean;
  canCreatePersonEvent: boolean;
}

export function EventNewSelectEventModal({teamId, canCreateClubEvent, canCreateTeamEvent, canCreatePersonEvent, onRequestClose, ...attributes}: EventNewSelectEventModalProps) {
  return (
    <Modal {...attributes} onRequestClose={onRequestClose} title={`Neuer Termin`} className="w-full max-w-lg">

      <ModalTitle>Neuer Termin</ModalTitle>

      <div className="flex flex-col gap-y-2 mt-4">
        {canCreateTeamEvent &&
          <Link className="button button--outline-secondary w-full flex justify-center text-lg"
                href={pwaEventNewPath({eventType: eventTypeSchema.enum.training, ...(teamId && {teamId: teamId!})})}>
            Training
          </Link>
        }
        {(canCreateClubEvent || canCreateTeamEvent || canCreatePersonEvent) && 
          <Link className="button button--outline-secondary w-full flex justify-center text-lg"
                href={pwaEventNewPath({eventType: eventTypeSchema.enum.other, ...(teamId && {teamId: teamId!})})}>
            Sonstiger Termin
          </Link>
        }
        {canCreateTeamEvent && teamId &&
          <Link className="button button--outline-secondary w-full flex justify-center text-lg"
                href={pwaEventNewPath({eventType: eventTypeSchema.enum.game, ...(teamId && {teamId: teamId!})})}>
            Freundschaftsspiel
          </Link>
        }
      </div>
    </Modal>
  );
}
